import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { IndividualTaoDataArgs, IndividualTaoDataResponse } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getIndividualTaoData = async (params: IndividualTaoDataArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<IndividualTaoDataResponse>(buildApiUrl("getIndividualTaoData"), { params });
  return data;
};

export const useIndividualTaoData = (taoId: number | undefined) => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<IndividualTaoDataResponse, Error>({
    queryKey: ["Tao-Routing-Individual-Tao_data", practiceId, requestedUser],
    queryFn: () => getIndividualTaoData({ practiceId, requestedUser, taoId }),
    enabled: !!taoId
  });
};
